export default __webpack_public_path__ + "static/media/AMGAS-full-logo.4a9ad416.png";